import { render } from "./Images.vue?vue&type=template&id=4d11ffed"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/wilsus-portal/wilsus-portal/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__